// src/routes/AppRoutes.jsx
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import LoginPage             from "../components/Auth/LoginPage";
import OTPVerificationPage   from "../components/Auth/OTPVerificationPage";
import ProtectedRoute        from "../components/Auth/ProtectedRoute";
import HomePage              from "../components/HomePage/HomePage";
import PlanningFormPage      from "../components/features/Planning/pages/PlanningFormPage";
import StructureFormPage     from "../components/features/Structure/pages/StructureFormPage";
import ElevationFormPage     from "../components/features/Elevation/pages/ElevationFormPage";
import InteriorFormPage      from "../components/features/Interior/pages/InteriorFormPage";
import ThankYouPage          from "../components/features/Planning/pages/ThankYouPage";
import { extractProjectLink } from "../utils/linkNormalizer";

// ─── Unknown route handler ─────────────────────────────────────────────────
// Pehle "*" seedha /login pe bhej deta tha — koi bhi link jo literal route
// se match nahi karta (case difference, query-param based projectId, extra
// slash, wagera) chupchaap "login link is not valid" error de deta tha,
// kyunki ProtectedRoute kabhi chalta hi nahi tha (isliye redirect URL save
// hi nahi hota tha).
//
// Ab yahan pehle ek try karte hain: agar current URL mein kahin bhi ek
// pehchana hua module (planning/structure/elevation/interior) + project id
// mil jaaye — chahe kisi bhi format mein ho — to seedha uske canonical
// "/module/:id" route pe bhej do. Wahan se normal ProtectedRoute flow chalega
// aur redirect URL sahi se save hoga. Sirf tabhi /login pe bhejte hain jab
// genuinely koi project link identify hi nahi ho paaya.
function UnknownRouteRedirect() {
  const location = useLocation();
  const rawUrl = location.pathname + location.search;
  const canonical = extractProjectLink(rawUrl);
  return <Navigate to={canonical || "/login"} replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login"       element={<LoginPage />} />
      <Route path="/verify-otp"  element={<OTPVerificationPage />} />
      <Route path="/thank-you"   element={<ThankYouPage />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        }
      />

      {/* Planning Form - URL: /planning/:projectId?updatedby=admin&token=xxx */}
      <Route
        path="/planning/:projectId"
        element={
          <ProtectedRoute>
            <PlanningFormPage />
          </ProtectedRoute>
        }
      />
      {/* Planning Form (query-param variant) - URL: /planning?projectId=xxx
          Kuch channels (e.g. WhatsApp template CTA buttons) path mein "/"
          allow nahi karte, isliye projectId query param se bhi aa sakta hai.
          PlanningFormPage ab dono jagah se projectId padh leta hai. */}
      <Route
        path="/planning"
        element={
          <ProtectedRoute>
            <PlanningFormPage />
          </ProtectedRoute>
        }
      />

      {/* Structure Form - URL: /structure/:projectId?updatedby=admin&token=xxx */}
      <Route
        path="/structure/:projectId"
        element={
          <ProtectedRoute>
            <StructureFormPage />
          </ProtectedRoute>
        }
      />
      {/* Structure Form (query-param variant) - URL: /structure?projectId=xxx */}
      <Route
        path="/structure"
        element={
          <ProtectedRoute>
            <StructureFormPage />
          </ProtectedRoute>
        }
      />

      {/* Elevation Form - URL: /elevation/:projectId?updatedby=admin&token=xxx */}
      <Route
        path="/elevation/:projectId"
        element={
          <ProtectedRoute>
            <ElevationFormPage />
          </ProtectedRoute>
        }
      />
      {/* Elevation Form (query-param variant) - URL: /elevation?projectId=xxx */}
      <Route
        path="/elevation"
        element={
          <ProtectedRoute>
            <ElevationFormPage />
          </ProtectedRoute>
        }
      />

      {/* Interior Form - URL: /interior/:projectId?updatedby=admin&token=xxx */}
      <Route
        path="/interior/:projectId"
        element={
          <ProtectedRoute>
            <InteriorFormPage />
          </ProtectedRoute>
        }
      />
      {/* Interior Form (query-param variant) - URL: /interior?projectId=xxx */}
      <Route
        path="/interior"
        element={
          <ProtectedRoute>
            <InteriorFormPage />
          </ProtectedRoute>
        }
      />

      {/* Koi bhi unknown/unexpected URL shape — normalizer se pehle canonical
          link nikalne ki koshish karo, tabhi login pe bounce karo. */}
      <Route path="*" element={<UnknownRouteRedirect />} />
    </Routes>
  );
}